import tmhRequest from "@/config/tmhRequest";

export default {
  searchRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/searchrechargeorder",
      method: "post",
      params: data
    });
  },
  searchListRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/searchlistrechargeorder",
      method: "post",
      params: data
    });
  },
  searchRechargeOrderCount: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/searchrechargeordercount",
      method: "post",
      data: data
    });
  },
  searchRechargeOrderByPage: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/searchrechargeorderbypage",
      method: "post",
      data: data
    });
  },
  initTargetBeautician: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/inittargetbeautician",
      method: "post",
      params: data
    });
  },
  initTargetAdviser: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/inittargetadviser",
      method: "post",
      params: data
    });
  },
  initTargetGiftCard: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/inittargetgiftcard",
      method: "post",
      data: data
    });
  },
  createRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/createrechargeorder",
      method: "post",
      data: data
    });
  },
  closeRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/closerechargeorder",
      method: "post",
      params: data
    });
  },
  initTargetBalance: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/inittargetbalance",
      method: "post",
      params: data
    });
  },

  initTargetMyCard: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/inittargetmycard",
      method: "post",
      params: data
    });
  },
  mixPayRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/mixpayrechargeorder",
      method: "post",
      data: data
    });
  },
  payRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/payrechargeorder",
      method: "post",
      data: data
    });
  },
  payOrderBalance: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/payorderbalance",
      method: "post",
      data: data
    });
  },

  initTodAssginRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/inittodassginrechargeorder",
      method: "post",
      params: data
    });
  },
  confirmAssginRechargeOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/confirmassginrechargeorder",
      method: "post",
      data: data
    });
  },
  resetPerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/resetperformance",
      method: "post",
      data: data
    });
  },

  repairEmployeePerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/rechargeorder/repairemployeeperformance",
      method: "post",
      params: data
    });
  },

  searchListIspaRechargeOrder: function(data) {
    return tmhRequest({
      url: "/ispa/order/isparechargeorder/searchlistisparechargeorder",
      method: "post",
      params: data
    });
  },

  transferRechargeOrder: function(data) {
    return tmhRequest({
      url: "/ispa/order/rechargeorder/transferrechargeorder",
      method: "post",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/order/rechargeorder.js